/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Custom_TitleInputs */

const en_admin_settings_custom_title = /** @type {(inputs: Admin_Settings_Custom_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom Configs`)
};

const zh_admin_settings_custom_title = /** @type {(inputs: Admin_Settings_Custom_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自定义配置`)
};

/**
* | output |
* | --- |
* | "Custom Configs" |
*
* @param {Admin_Settings_Custom_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_custom_title = /** @type {((inputs?: Admin_Settings_Custom_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Custom_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_custom_title(inputs)
	return zh_admin_settings_custom_title(inputs)
});
export { admin_settings_custom_title as "admin.settings.custom.title" }